/**
 * Combine date and time for datetime-local input.
 * @param {Date} date - The date.
 * @param {string} time - The time.
 * @returns {string} The combined date and time.
 */
const combineDateTime = (date, time) => {
  if (!date || !time) return '';
  const dateTime = new Date(`${date}T${time}`);
  dateTime.setHours(dateTime.getHours() + 2);
  return dateTime.toISOString().slice(0, 16); // Format for datetime-local input
};

/**
 * Add one hour to the published date.
 * @param {Date} date - The published date.
 * @param {number} nb - The number of hours to add.
 * @returns {Date|null} The published date with one hour added.
 */
const addHourToDate = (date, nb) => {
  if (!date) return null;
  const dateTime = new Date(date);
  dateTime.setHours(dateTime.getHours() + nb);
  return new Date(dateTime);
};

export {
  combineDateTime,
  addHourToDate,
};
